import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";
import dayjs, { Dayjs } from "dayjs";

export const IndicatorUploadDataSchema = z
  .object({
    partnerOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    frequencyOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),
    year: z.custom<Dayjs>((val) => dayjs(val).isValid(), {
      message: REQUIRED_FIELD,
    }),
    frequencyData: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data?.frequencyOption.id !== 6 && !data.frequencyData) {
      ctx.addIssue({
        path: ["frequencyData"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
  });
